import React from "react";
import Placeholder from "./Placeholder";
import SimpleCentered from "./SimpleCentered";
import ProductListing from "./ProductListing";
import WithLargeImages from "./WithLargeImages";
import TwoColumnCards from "./TwoColumnCards";
import LogoClouds from "./LogoClouds";
import Audio from "./Audio";

/* Marketing / PageSections / ContentSections */
import TwoColumns from "./Marketing/PageSections/ContentSections/TwoColumns";
import TwoColumnsWithImage from "./Marketing/PageSections/ContentSections/TwoColumnsWithImage";
import TwoColumnsWithImageWebinar from "./Marketing/PageSections/ContentSections/TwoColumnsWithImageWebinar";
import Stat from "./Marketing/PageSections/ContentSections/Stat";
import TwoColumnsImages from "./Marketing/PageSections/ContentSections/TwoColumnsImages";
import ThreeColumns from "./Marketing/PageSections/ContentSections/ThreeColumns";
import WithFeatureList from "./Marketing/PageSections/ContentSections/WithFeatureList";
import FullWidthImage from "./Marketing/PageSections/ContentSections/FullWidthImage";
import FourByTwoGridOnBrandV1 from "./Marketing/PageSections/ContentSections/FourByTwoGridOnBrandV1";
import FourByTwoGridOnBrandV2 from "./Marketing/PageSections/ContentSections/FourByTwoGridOnBrandV2";
import FourByTwoGridOnBrandWithFilter from "./Marketing/PageSections/ContentSections/FourByTwoGridOnBrandWithFilter";

/* Marketing / PageSections / Contact Sections */
import ContactSplitTwoTone from "./Marketing/PageSections/ContactSections/SplitTwoTone";
import NewsletterSplitTwoTone from "./Marketing/PageSections/ContactSections/NewsletterSplitTwoTone";
import ContactSimpleFourColumn from "./Marketing/PageSections/ContactSections/SimpleFourColumn";
import ContactForm from "./Forms/ContactForm"

/* Marketing / PageSections / Stats */
import SimpleOnBrand from "./Marketing/PageSections/Stats/SimpleOnBrand";

/* Marketing / PageSections / CTA Sections */
import BrandPanelOverlappingImage from "./Marketing/PageSections/CTASections/brand-panel-with-overlapping-image";
import CtaSimpleJustified from "./Marketing/PageSections/CTASections/CtaSimpleJustified";
import CtaSplitWithImage from "./Marketing/PageSections/CTASections/CtaSplitWithImage";
import ColourPickerCta from "./Marketing/PageSections/CTASections/ColourPickerButton";

/* Marketing / PageSections / Testimonials */
import TestimonialsSimpleCentered from "./Marketing/PageSections/Testimonials/SimpleCentered";
import TestimonialLargeAvatar from "./Marketing/PageSections/Testimonials/TestimonialLargeAvatar";

/* TBB */
import Hero from "./TBB/Heros/Hero";
import SlimlineHero from "./TBB/Heros/SlimlineHero";
import TitleAndDate from "./TBB/TitleAndDate";
import TwoColumnsWithVideo from "./Marketing/PageSections/ContentSections/TwoColumnsWithVideo";

/* Custom */
import GoogleMap from "./Custom/GoogleMap";
import Video from "./Custom/Video";
import CustomMagazine from './Custom/CustomMagazine'
import CustomFourColumn from './Custom/CustomFourColumn'
import Calendly from "./Calendly";

/* Search */
import Search from "./Search";

import Breadcrumbs from "./Breadcrumbs";
import GatedContentForm from "./Marketing/PageSections/ContactSections/GatedContentForm";
import EventSignupForm from "./Marketing/PageSections/ContactSections/EventSignupForm";
import Product from "./Product";

const Components = {
  hero: Hero,
  "slimline-hero": SlimlineHero,
  "simple-centered": SimpleCentered,
  "with-large-images": WithLargeImages,
  "two-column-cards": TwoColumnCards,
  "logo-clouds": LogoClouds,
  "audio": Audio,
  /* Marketing / PageSections / ContentSections */
  "two-columns": TwoColumns,
  "two-columns-with-image": TwoColumnsWithImage,
  "two-columns-with-image-webinar": TwoColumnsWithImageWebinar,
  stat: Stat,
  /* Marketing / PageSections / Stats */
  "simple-on-brand": SimpleOnBrand,
  /* Marketing / PageSections / CTA Sections */
  "brand-panel-overlapping-image": BrandPanelOverlappingImage,
  /* Marketing / PageSections / Contact Sections */
  "contact-split-two-tone": ContactSplitTwoTone,
  "newsletter-split-two-tone": NewsletterSplitTwoTone,
  "contact-simple-four-column": ContactSimpleFourColumn,
  "contact-form": ContactForm,

  /* Marketing / PageSections / Testimonials */
  "testimonial-simple-centered": TestimonialsSimpleCentered,
  /* TBB */
  "title-and-date": TitleAndDate,
  "two-columns-with-video": TwoColumnsWithVideo,
  /* Custom */
  "video": Video,
  "google-map": GoogleMap,
  "product-listing": ProductListing,
  "two-columns-images": TwoColumnsImages,
  "cta-simple-justified": CtaSimpleJustified,
  "colour-picker-button": ColourPickerCta,
  "search": Search,
  "custom-magazine": CustomMagazine,
  "with-feature-list": WithFeatureList,
  "testimonial-large-avatar": TestimonialLargeAvatar,
  "full-width-image": FullWidthImage,
  "cta-split-with-image": CtaSplitWithImage,
  "three-columns": ThreeColumns,
  "four-by-two-grid-on-brand-v1": FourByTwoGridOnBrandV1,
  "four-by-two-grid-on-brand-v2": FourByTwoGridOnBrandV2,
  "four-by-two-grid-on-brand-with-filter": FourByTwoGridOnBrandWithFilter,
  "custom-four-column": CustomFourColumn,
  "breadcrumbs": Breadcrumbs,
  "gated-content-form": GatedContentForm,
  "event-signup-form": EventSignupForm,
  "product": Product,
  "calendly" : Calendly
};

const DynamicComponent = ({ blok }) => {
  if (typeof Components[blok.component] !== "undefined") {
    const Component = Components[blok.component];
    return <Component blok={blok} key={blok._uid} />;
  }

  return blok.component ? <Placeholder componentName={blok.component} /> : null;
};

export default DynamicComponent;
